import { useEffect, useState } from 'react';
import { LeaveRequestApi } from '../../../api';
import { LeaveRequestDto } from '../../../commonTypes/leaveRequest.types';
import { useContainer } from '../../useContainer';

const useHttpGetLeaveRequestsOnMountAndExecute = (page?: number, size?: number, sort?: string, direction?: 'asc' | 'desc') => {
    const leaveRequestApi: LeaveRequestApi = useContainer(LeaveRequestApi);
    const [data, setData] = useState<LeaveRequestDto[]>([]);
    const [total, setTotal] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(true);

    const { exec, abort } = leaveRequestApi.requestsForUser({
        query: {
            ...(page && { page }),
            ...(size && { size }),
            ...(sort && { sort }),
            ...(direction && { direction }),
        },
        onSuccess: res => {
            const requestsForUser = res.body;
            setData(requestsForUser.items);
            setTotal(parseInt(requestsForUser.total));
            setLoading(false);
        },
        onError: error => {
            console.log(error);
            setLoading(false);
        },
    });

    useEffect(() => {
        return () => abort();
    }, []);

    return { exec, abort, data, setData, total, setTotal, loading, setLoading };
};

export default useHttpGetLeaveRequestsOnMountAndExecute;
